<template>
  <div class="claim-edit">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="editForm" :model="claimModel"
          :rules="modelValidate"
          label-position="right"
          :label-width="160">
          <FormItem label="项目名称" v-if="guaranteeModel&&guaranteeModel.project">
            <span>{{guaranteeModel.project.name}}</span>
          </FormItem>
          <FormItem label="代偿方式" prop="method">
            <Select v-model="claimModel.method" filterable>
              <Option v-for="(tp,idx) in $common.getEnumSelect($common.claimMethod)" :key="idx" :value="tp.value">{{tp.value}}</Option>
            </Select>
          </FormItem>
          <FormItem label="责任主体">
            <RadioGroup v-model="subject" type="button">
              <Radio label="承包商"></Radio>
              <Radio label="业主"></Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="业主原因" prop="reasonByOwner" v-if="subject==='业主'"
            :ruls="subject==='业主'?[{required:true,message: '原因不能为空',trigger: 'blur'}]:[]">
            <Select v-model="claimModel.reasonByOwner" filterable>
              <Option v-for="(tp,idx) in $common.getEnumSelect($common.claimReasonByOwner)" :key="idx" :value="tp.value">{{tp.value}}</Option>
            </Select>
          </FormItem>
          <FormItem label="承包商原因" prop="reasonByContractor" v-if="subject==='承包商'"
            :ruls="subject==='业主'?[{required:true,message: '原因不能为空',trigger: 'blur'}]:[]">
            <Select v-model="claimModel.reasonByContractor" filterable>
              <Option v-for="(tp,idx) in $common.getEnumSelect($common.claimReasonByContractor)" :key="idx" :value="tp.value">{{tp.value}}</Option>
            </Select>
          </FormItem>
          <FormItem label="其他原因" prop="otherReason"
            :ruls="claimModel.reasonByContractor==='其他'||claimModel.reasonByOwner==='其他'?[{required:true,message: '原因不能为空',trigger: 'blur'}]:[]"
            v-if="claimModel.reasonByContractor==='其他'||claimModel.reasonByOwner==='其他'">
            <Input v-model="claimModel.otherReason"
              maxlength="500"
              show-word-limit
              type="textarea"
              placeholder="请输入其他原因" />
          </FormItem>
          <FormItem label="保额" v-if="guaranteeModel">
            <span>{{guaranteeModel.amount/100/10000}}万元</span>
          </FormItem>
          <FormItem label="索赔金额(元)" prop="amount">
            <InputNumber :min="0" :step="10000"
              style="width: 150px;display:inline-block"
              v-model="claimModel.amount"
              placeholder="输入索赔金额(元)"></InputNumber>
            <Divider type="vertical" v-if="claimModel.amount" />
            <h3 style="display:inline-block" v-if="claimModel.amount"> {{`¥ ${claimModel.amount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
            <Divider type="vertical" v-if="claimModel.amount" />
            <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(claimModel.amount)}}</h3>
          </FormItem>
          <FormItem label="保证金额度" v-if="guaranteeModel&&guaranteeModel.counterCash">
            <span>{{guaranteeModel.counterCash/100/10000}}万元</span>
          </FormItem>
          <FormItem label="使用保证金金额(元)" prop="depositUsed" v-if="guaranteeModel&&guaranteeModel.counterCash">
            <InputNumber :min="0" :step="10000"
              style="width: 150px;display:inline-block"
              v-model="claimModel.depositUsed"
              placeholder="输入索赔金额(元)"></InputNumber>
            <Divider type="vertical" v-if="claimModel.depositUsed" />
            <h3 style="display:inline-block" v-if="claimModel.depositUsed"> {{`¥ ${claimModel.depositUsed}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</h3>
            <Divider type="vertical" v-if="claimModel.depositUsed" />
            <h3 style="display:inline-block">{{$common.transformNumberIntoCHS(claimModel.depositUsed)}}</h3>
          </FormItem>
          <FormItem
            :label="att.name"
            :prop="`attachments[${idx}].url`"
            v-for="(att,idx) in claimModel.attachments"
            :key="idx"
            :rules="att.required?[{required:true,validator:arrayValidator,trigger:'change'}]:[]">
            <Upload
              ref="attachmentUploader"
              :data="OSSParam"
              :before-upload="handleBeforeUpload"
              :multiple="true"
              :max-size="att.fileSizeLimit"
              :on-success="handleUploadSuccess"
              :format="getFormats(att.formats)"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleExceededSize"
              :on-remove="removeItem"
              :on-preview="previewUploaded"
              :show-upload-list="false"
              :action="uploadParams.host">
              <Poptip trigger="hover" placement="bottom">
                <Button @click="getOSSParams(idx, att.name)"><Icon type="ios-cloud-upload-outline"></Icon>上传附件</Button>
                <div slot="content">
                  <span class="small font-grey">格式要求:{{att.formats}}<br>文件大小限制: {{att.fileSizeLimit}}kb<br>文件数量上限: {{att.fileCountLimit}}</span>
                </div>
              </Poptip>
            </Upload>
            <div class="attachments">
              <div class="attachment-thumb"
                @click="previewImgUrl=item;showPreview=true"
                :key="index"
                v-for="(item,index) in att.url">
                <img :src="item.url" v-if="item&&item.url&&item.type==='image'">
                <span style="font-weight:bold;color:#999" v-if="item&&item.url&&item.type==='file'">{{item.surfix.toUpperCase()}}</span>
                <div class="attachment-thumb-cover">
                  <Icon type="ios-eye-outline" @click.stop="previewImgUrl=item;showPreview=true"></Icon>
                  <Icon type="ios-trash-outline" @click.stop="removeItem(item, idx)"></Icon>
                </div>
              </div>
            </div>
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
    <Modal v-model="showPreview" title="查看图片" @on-cancel="showPreview=false;previewImgUrl=null">
      <img :src="previewImgUrl" v-if="showPreview&&typeof(previewImgUrl)==='string'" style="width: 100%">
      <img :src="previewImgUrl.url" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='image'" style="width: 100%">
      <a :href="previewImgUrl.url" target="_blank" v-if="showPreview&&typeof(previewImgUrl)==='object'&&previewImgUrl.url&&previewImgUrl.type==='file'">查看</a>
    </Modal>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'claim-edit',
  props: {
  },
  data () {
    return {
      loading: false,
      claimModel: {
        id: null,
        guaranteeId: null,
        reasonByOwner: null,
        reasonByContractor: null,
        method: null,
        amount: null,
        depositUsed: null,
        attachments: [],
        otherReason: null
      },
      subject: '承包商',
      guaranteeModel: {
        orderNumber: null
      },
      supvPerms: {
        canAudit: false,
        canPreAudit: false,
        canAuditTerminate: false,
        canAuditRenewal: false,
        canClaim: false
      },
      modelValidate: {
        guaranteeId: [
          { required: true, type: 'number', message: '保函不存在', trigger: 'blur' }
        ],
        method: [
          { required: true, message: '代偿方式不能为空', trigger: 'blur' }
        ],
        amount: [
          { required: true, type: 'number', message: '请填写代偿金额', trigger: 'blur' },
          { validator: this.guaAmountValidator, trigger: 'change' }
        ],
        depositUsed: [
          { validator: this.guaDepositAmountValidator, trigger: 'change' }
        ]
      },
      uploadParams: {
        accessid: '',
        host: '',
        policy: '',
        signature: '',
        callbackbody: '',
        key: '',
        expire: 0
      },
      OSSParams: [],
      OSSParam: {
        name: '',
        key: '',
        policy: '',
        OSSAccessKeyId: '',
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: '',
        fileIndex: 0
      },
      curOSSParamIndex: 0,
      previewImgUrl: null,
      showPreview: false
    }
  },
  watch: {
    '$route.params.id': function (newVal) {
      if (newVal) {
        this.getClaimDetail()
      }
    },
    '$route.params.orderNumber': function (newVal) {
      if (newVal) {
        this.getGuaranteeDetail()
      }
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.getClaimDetail()
    } else {
      this.$Modal.error({
        title: '错误',
        content: '代偿编号为空',
        onOk: () => {
          this.$router.back()
        }
      })
    }
    if (this.$route.params.orderNumber) {
      this.getGuaranteeDetail()
      this.initAttachment()
    } else {
      this.$Modal.error({
        title: '错误',
        content: '保函编号为空',
        onOk: () => {
          this.$router.back()
        }
      })
    }
  },
  activated () {
  },
  deactivated () {
  },
  computed: {
    totalGuaAmount () {
      let mainAmount = this.guaranteeModel.amount || 0
      let jointAmount = 0
      if (this.guaranteeModel && this.guaranteeModel.jointGuarantors && this.guaranteeModel.jointGuarantors.length) {
        this.guaranteeModel.jointGuarantors.forEach((j) => {
          jointAmount += j.amount
        })
      }
      return mainAmount + jointAmount
    },
    totalGuaDepositAmount () {
      let mainAmount = this.guaranteeModel.counterCash || 0
      let jointAmount = 0
      if (this.guaranteeModel && this.guaranteeModel.jointGuarantors && this.guaranteeModel.jointGuarantors.length) {
        this.guaranteeModel.jointGuarantors.forEach((j) => {
          jointAmount += j.counterCash
        })
      }
      return mainAmount + jointAmount
    }
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
    guaAmountValidator (rule, value, callback) {
      console.log(value * 100, this.totalGuaAmount)
      if (value * 100 <= this.totalGuaAmount) {
        callback()
      } else {
        callback(new Error('索赔额度不能超过保额'))
      }
    },
    guaDepositAmountValidator (rule, value, callback) {
      if (value * 100 <= this.totalGuaDepositAmount) {
        callback()
      } else {
        callback(new Error('保证金使用额度超过保函保证金总额'))
      }
    },
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1 && this.permitted
      }
      return roles == userRole && this.permitted
    },
    getClaimDetail () {
      Api.Guarantee.getClaimDetail(this.$route.params.id).then(async (res) => {
        Object.assign(this.claimModel, res)
        if ([1, 2].indexOf(this.claimModel.status) > -1 || (this.claimModel.status === 0 && !this.claimModel.needAudit)) {
          this.$Modal.error({
            title: '错误',
            content: '状态不允许修改',
            onOk: () => {
              this.$router.back()
            }
          })
        }
        this.claimModel.guaranteeId = res.id
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
      })
    },
    getGuaranteeDetail () {
      Api.Guarantee.getGuaranteeDetail(this.$route.params.orderNumber).then(async (res) => {
        this.guaranteeModel = {
          remarks: null
        }
        Object.assign(this.guaranteeModel, res)
        if (this.checkRolePermitted(['监管人','总监管人'])) {
          this.getSupervisionPermission()
        }
        if ([1, 2, 4].indexOf(this.guaranteeModel.status) < 0) {
          this.$Modal.error({
            title: '错误',
            content: '保函状态不允许发起代偿',
            onOk: () => {
              this.$router.back()
            }
          })
        }
        this.claimModel.guaranteeId = res.id
      }).catch(err => {
        this.$Message.error('获取保函详情失败!' + err.message)
      })
    },
    async getSupervisionPermission () {
      await this.$Api.Guarantee.getSupervisionPermission(this.$route.params.orderNumber)
      .then((res) => {
        console.log(res)
        Object.assign(this.supvPerms, res)
      })
      .catch(() => {
        this.supvPerms = {
          canAudit: false,
          canPreAudit: false,
          canAuditTerminate: false,
          canAuditRenewal: false,
          canClaim: false
        }
      })
    },
    async submit () {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: '确认操作',
            content: '<p>确认修改代偿么？</p>',
            onOk: () => {
              this.doSubmit()
            }
          })
        }
      })
    },
    async doSubmit () {
      this.loading = true
      this.$Spin.show()
      let model = Object.assign({}, this.claimModel)
      model.amount = Math.round(model.amount * 100)
      model.depositUsed = Math.round(model.depositUsed * 100)
      if (model.reasonByOwner === '其他') {
        if (!model.otherReason) {
          this.$Message.error('其他原因不能为空!')
          return false
        } else {
          model.reasonByOwner += '-' + model.otherReason
        }
      }
      if (model.reasonByContractor === '其他') {
        if (!model.otherReason) {
          this.$Message.error('其他原因不能为空!')
          return false
        } else {
          model.reasonByContractor += '-' + model.otherReason
        }
      }
      let urls = []
      model.attachments.forEach((att) => {
        if (att.url instanceof Array) {
          urls = urls.concat(att.url.map((u) => {
            return u.name.replace('oss:', '')
          }))
        }
      })
      model.attachments = urls
      await Api.Guarantee.editClaim(model)
        .then((payload) => {
          console.log('suc', payload)
          this.$Message.success('操作成功!')
          this.claimModel= {
            guaranteeId: null,
            reasonByOwner: null,
            reasonByContractor: null,
            method: null,
            amount: null,
            depositUsed: null,
            attachments: [],
            otherReason: null
          }
          this.loading = false
          this.$Spin.hide()
          this.$router.back()
        })
        .catch(err => {
          console.log('err', err)
          this.$Message.error('提交失败!' + err.message)
          this.loading = false
          this.$Spin.hide()
        })
    },
    initAttachment () {
      let attaches = this.getConfig('GUARANTEE_CLAIM_ATTACHMENT_REQUIREMENTS')
      if (attaches && attaches instanceof Array && attaches.length) {
        this.claimModel.attachments = attaches.map(a => {
          a.filePath = null
          a.ossKeys = []
          a.url = []
          return a
        })
      }
    },
    arrayValidator (rule, value, callback) {
      if (!value || !(value instanceof Array) || !value.length) {
        callback(new Error('没有元素'))
      } else {
        callback()
      }
    },
    getFormats (fmtStr) {
      let arr = fmtStr.split(',')
      let result = arr.map((a) => {
        return a.trim()
      })
      return result
    },
    getOSSParams (index, name, type = 3) {
      // type: 1-合同|2-竣工|3-其他
      this.$Api.Guarantee.getUploadParams(type).then((res) => {
        console.log(res)
        this.uploadParams = {
          name: name,
          accessid: res.accessid,
          host: res.host,
          policy: res.policy,
          signature: res.signature,
          callbackbody: res.callbackbody,
          key: res.dir,
          expire: res.expire
        }
        this.uploadParams.host = this.uploadParams.host.replace('-internal', '')
        this.curOSSParamIndex = index    // 上传控件序号
      }).catch(err => {
        this.$Message.error(err.message)
      })
    },
    handleBeforeUpload (file) {
      let filename = this.uploadParams.key + this.randomString(10) + this.getSuffix(file.name)
      this.OSSParams[this.curOSSParamIndex] = {
        name: file.name,
        key: filename,
        policy: this.uploadParams.policy,
        OSSAccessKeyId: this.uploadParams.accessid,
        success_action_status: '200',   // 让服务端返回200,不然，默认会返回204
        signature: this.uploadParams.signature,
        fileIndex: this.curOSSParamIndex
      }
      this.OSSParam.name = file.name
      this.OSSParam.key = filename
      this.OSSParam.policy = this.uploadParams.policy
      this.OSSParam.OSSAccessKeyId = this.uploadParams.accessid
      this.OSSParam.success_action_status = '200'   // 让服务端返回200,不然，默认会返回204
      this.OSSParam.signature = this.uploadParams.signature
      this.OSSParam.fileIndex = this.curOSSParamIndex
    },
    async handleUploadSuccess (response, file, fileList) {
      let index = this.OSSParams.findIndex(o => o && o.name === file.name)
      let attach = this.claimModel.attachments[index]
      if (fileList.length > attach.fileCountLimit) {
        fileList.splice(0, 1)
        this.claimModel.attachments[index].ossKeys.splice(0, 1)
      }
      if (!this.claimModel.attachments[index].ossKeys) {
        this.claimModel.attachments[index].ossKeys = []
      }
      if (!this.claimModel.attachments[index].url) {
        this.claimModel.attachments[index].url = []
      }
      let ossParam = this.OSSParams[index]
      let filename = 'oss:' + ossParam.key
      file.name = filename
      this.$nextTick(async () => {
        await this.procOssKey(filename).then(url => {
          url.status = 'finished'
          this.claimModel.attachments[index].url.push(url)
        })
        this.claimModel.attachments[index].ossKeys.push(filename)
        this.claimModel.attachments[index].filePath = this.claimModel.attachments[index].ossKeys.join(',')
      })
    },
    removeItem (item, attachIdx) {
      let attach = this.claimModel.attachments[attachIdx]
      let idx = attach.url.findIndex(o => o.name === item.name)
      attach.url.splice(idx, 1)
      let keys = attach.filePath.split(',')
      keys.splice(idx, 1)
      keys = keys.join(',')
      console.log(keys)
      this.claimModel.attachments[attachIdx].ossKeys = keys
      this.claimModel.attachments[attachIdx].filePath = keys
    },
    previewUploaded (file) {
      let key = file.name.indexOf('oss:') === 0 ? file.name.substr(4) : file.name
      this.procOssKey(key).then((obj) => {
        console.log(obj)
        this.previewImgUrl = obj.url
        this.showPreview = true
      })
    },
    async procOssKey (k) {
      let url = await this.procOSSUrl(k)
      return new Promise((resolve) => {
        let surfix = url.substr(url.lastIndexOf('.') + 1).toLowerCase()
        if (surfix.indexOf('?')) {
          surfix = surfix.substring(0, surfix.indexOf('?'))
        }
        let type = 'image'
        switch (surfix) {
          case 'jpg':
            type = 'image'
            break
          case 'jpeg':
            type = 'image'
            break
          case 'png':
            type = 'image'
            break
          case 'gif':
            type = 'image'
            break
          case 'pdf':
            type = 'file'
            break
          case 'doc':
            type = 'file'
            break
          case 'docx':
            type = 'file'
            break
          case 'xls':
            type = 'file'
            break
          case 'xlsx':
            type = 'file'
            break
          case 'ppt':
            type = 'file'
            break
          case 'pptx':
            type = 'file'
            break
          default:
            type = 'file'
            break
        }
        resolve({
          name: k,
          url,
          type,
          surfix
        })
      })
    },
    procOSSUrl (_key) {
      return new Promise((resolve, reject) => {
        let url = ''
        let ossKey = window.encodeURIComponent(window.btoa(_key))
        Api.Guarantee.getOssUrl(ossKey).then((res) => {
          // console.log(typeof(res), res)
          url = res
          resolve(url)
        }).catch(err => {
          this.$Message.error('获取文件地址失败!' + err.message)
          reject(err)
        })
      })
    },
    handleFormatError () {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '上传文件格式不正确。'
      })
    },
    handleExceededSize () {
      this.$Notice.warning({
        title: '文件大小超出限制',
        desc: '上传文件大小超出限制范围。'
      })
    },
    randomString (len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },
    getSuffix (filename) {
      let pos = filename.lastIndexOf('.')
      let suffix = ''
      if (pos !== -1) {
        suffix = filename.substring(pos)
      }
      return suffix
    },
  }
}
</script>

<style lang="less">
</style>
